import type { OrbitSlice } from '../Common/Orbit/orbitTypes'
import { datasetId, slice, targetlessSlice, type OrbitActionBridge } from '../Common/Orbit/orbitSliceHelpers'
import { AssignIcon, CompleteIcon, ConvertToTaskIcon, DeleteIcon, DuplicateIcon, EditIcon, NewTaskIcon, OpenIcon, PingIcon, RemoveIcon, RescheduleIcon } from '../Common/Orbit/icons'

export type MeetingOrbitAction = OrbitActionBridge
const meetingId = (node: HTMLElement) => datasetId(node, 'meetingId', 'attendeeId', 'agendaId', 'actionId')

// TODO(orbit-phase-3-followup): re-add Share once a sharing primitive exists.
export const buildMeetingCardSlices = (node: HTMLElement, action: MeetingOrbitAction): OrbitSlice[] => [
  slice('meeting-open', 'Open', OpenIcon, action, node, meetingId),
  slice('meeting-duplicate', 'Duplicate', DuplicateIcon, action, node, meetingId),
  slice('meeting-reschedule', 'Reschedule', RescheduleIcon, action, node, meetingId),
  slice('meeting-delete', 'Delete', DeleteIcon, action, node, meetingId),
]
export const buildAttendeeChipSlices = (node: HTMLElement, action: MeetingOrbitAction): OrbitSlice[] => [
  slice('attendee-ping', 'Ping', PingIcon, action, node, meetingId),
  slice('attendee-assign', 'Assign', AssignIcon, action, node, meetingId),
  slice('attendee-remove', 'Remove', RemoveIcon, action, node, meetingId),
]
export const buildAgendaItemSlices = (node: HTMLElement, action: MeetingOrbitAction): OrbitSlice[] => [
  slice('agenda-edit', 'Edit', EditIcon, action, node, meetingId),
  slice('agenda-convert', 'Convert to task', ConvertToTaskIcon, action, node, meetingId),
  slice('agenda-delete', 'Delete', DeleteIcon, action, node, meetingId),
]
export const buildActionItemSlices = (node: HTMLElement, action: MeetingOrbitAction): OrbitSlice[] => [
  slice('action-complete', 'Complete', CompleteIcon, action, node, meetingId),
  slice('action-assign', 'Assign', AssignIcon, action, node, meetingId),
  slice('action-delete', 'Delete', DeleteIcon, action, node, meetingId),
]
export const buildMeetingsCanvasSlices = (action: MeetingOrbitAction): OrbitSlice[] => [
  targetlessSlice('canvas-new-meeting', 'New meeting', OpenIcon, action),
  targetlessSlice('canvas-new-agenda-item', 'New agenda item', NewTaskIcon, action),
]
